import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function Businessgeo({ getData }) {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    getData(
      "Geo-IoT",
      "빌딩 내 각종 시설의 효율적인 관리기능을 3차원 공간상에서 직관적인 UI로 제공하여",
      "보다 효과적인 관리기능을 제공합니다."
    );
    window.addEventListener("scroll", updateScroll);
  }, [getData]);

  // 스크롤 pc
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      {pc ? (
        <div>
          <div className="inner">
            <h2 className="basic-title">Geo-IoT 보유 기술</h2>
            <div className="basic-subtitle">
              <p>다양한 기술을 바탕으로 각종 시설에 대한 관리 기능을</p>
              <p>보다 효율적으로 제공합니다.</p>
            </div>
            <div>
              <ul className="technology-list">
                <li className="technology-item">
                  <span className="technology-img geo-img1"></span>
                  <h2 className="technology-name">
                    디저털 트윈의 축소(일부 공간 지원)
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img2"></span>
                  <h2 className="technology-name">
                    사물 인터넷과 공간정보 연계 기술
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img3"></span>
                  <h2 className="technology-name">
                    스마트 빌딩 서비스 지원(BEMS)
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img4"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">
                      환경 센서 / 제어 센서 등을 통한
                    </span>
                    <span className="basic-block">
                      온도, 습도, 미세먼지 공간 표출
                    </span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img5"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">
                      딥러닝 기술을 통한 에너지
                    </span>
                    <span className="basic-block">수요 예측 / 고장 예측</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img6"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">
                      IoT 표준 프로토콜 지원(MQTT,
                    </span>
                    <span className="basic-block">
                      REST 등), IoT 전문회사 기술 협력
                    </span>
                  </h2>
                </li>
              </ul>
            </div>
          </div>

          <div
            className={
              scrollPosition > 1299
                ? "basic-banner geo-banner on"
                : "basic-banner geo-banner"
            }
          >
            <h2 className="basic-banner-title">
              <p className="txt">3차원 서비스로 데이터를</p>
              <p className="txt">연계하는 서비스</p>
            </h2>
          </div>

          <div className="inner">
            <ul className="business-list">
              <li className="business-item">
                <h2 className="business-title">건물에너지관리시스템(BEMS)</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      평면도 기반으로 3차원 데이터를 구축하고 IoT 센서
                      수집/분석/예측 데이터를 연계하여 인공지능을 통한 효율적
                      빌딩관리가 가능한 에너지 수요예측, 고장예측, 설비 제어
                      등과 같은 기능을 제공합니다.
                    </h3>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">관련 자료 협력사 제공</li>
                    <li className="basic-cont-item">
                      3차원 공간 정보 플랫폼(DiTAP) 기반 건설관리 패키지
                      개발(중소 벤처기업부)
                    </li>
                    <li className="basic-cont-item">
                      Unity 기반의 디지털트윈 GIS 적용 기술 및 솔루션
                      개발(과학기술정보통신부)
                    </li>
                    <li className="basic-cont-item">
                      XR 기반 건설 설계 혁신 시스템(정보통신산업진흥원)
                    </li>
                  </ul>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img geo-img1"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img geo-img2"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li className="business-item">
                <h2 className="business-title">
                  <span className="basic-block">재생에너지 자원</span>
                  <span className="basic-block">디지털트윈 서비스</span>
                </h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      전국단위 재생에너지 자원 디지털트윈 운영플랫폼 개발을
                      목표로하며 태양광 패널 배치 및 수정, 환경 정보에 따른
                      에너지 운영/예측 시뮬레이션을 제공합니다.
                    </h3>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">한국전기연구원 공동개발</li>
                  </ul>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img geo-img3"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img geo-img4"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        <div>
          <div className="inner">
            <h2 className="basic-title">
              <span className="txt">Geo-IoT</span>
              <span className="txt">보유 기술</span>
            </h2>
            <div className="basic-subtitle">
              <p>다양한 기술을 바탕으로 각종 시설에 대한 관리</p>
              <p>기능을 보다 효율적으로 제공합니다.</p>
            </div>
            <div>
              <ul className="technology-list">
                <li className="technology-item">
                  <span className="technology-img geo-img1"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">디저털 트윈의 축소</span>
                    <span className="basic-block">(일부 공간 지원)</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img2"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">사물 인터넷과 공간</span>
                    <span className="basic-block">정보 연계 기술</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img3"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">스마트 빌딩 서비스</span>
                    <span className="basic-block">지원(BEMS)</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img4"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">환경 센서 / 제어 센</span>
                    <span className="basic-block">서 등을 통한 온도,</span>
                    <span className="basic-block">
                      습도, 미세먼지 공간 표출
                    </span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img5"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">딥러닝 기술을 통한</span>
                    <span className="basic-block">에너지 수요 예측 /</span>
                    <span className="basic-block">고장 예측</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img geo-img6"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">IoT 표준 프로토콜</span>
                    <span className="basic-block">지원(MQTT, REST</span>
                    <span className="basic-block">등), IoT 전문회사</span>
                    <span className="basic-block">기술 협력</span>
                  </h2>
                </li>
              </ul>
            </div>
          </div>

          <div className="basic-banner geo-banner">
            <h2 className="basic-banner-title">
              <p className="txt">3차원 서비스로</p>
              <p className="txt">데이터를</p>
              <p className="txt">연계하는 서비스</p>
            </h2>
          </div>

          <div className="inner">
            <ul className="business-list">
              <li className="business-item">
                <h2 className="business-title">건물에너지관리시스템(BEMS)</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      평면도 기반으로 3차원 데이터를 구축하고 IoT 센서
                      수집/분석/예측 데이터를 연계하여 인공지능을 통한 효율적
                      빌딩관리가 가능한 에너지 수요예측, 고장예측, 설비 제어
                      등과 같은 기능을 제공합니다.
                    </h3>
                  </div>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img geo-img1"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img geo-img2"></span>
                      </li>
                    </ul>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">관련 자료 협력사 제공</li>
                    <li className="basic-cont-item">
                      3차원 공간 정보 플랫폼(DiTAP) 기반 건설관리 패키지
                      개발(중소 벤처기업부)
                    </li>
                    <li className="basic-cont-item">
                      Unity 기반의 디지털트윈 GIS 적용 기술 및 솔루션
                      개발(과학기술정보통신부)
                    </li>
                    <li className="basic-cont-item">
                      XR 기반 건설 설계 혁신 시스템(정보통신산업진흥원)
                    </li>
                  </ul>
                </div>
              </li>
              <li className="business-item">
                <h2 className="business-title">
                  재생에너지 자원디지털트윈 서비스
                </h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      전국단위 재생에너지 자원 디지털트윈 운영플랫폼 개발을
                      목표로하며 태양광 패널 배치 및 수정, 환경 정보에 따른
                      에너지 운영/예측 시뮬레이션을 제공합니다.
                    </h3>
                  </div>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img geo-img3"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img geo-img4"></span>
                      </li>
                    </ul>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">한국전기연구원 공동개발</li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default Businessgeo;
